
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 23 23"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.188 19.002H4.043V8.85h3.145v10.152zm.314-13.387a1.842 1.842 0 10-3.684 0 1.842 1.842 0 003.684 0zm11.455 7.801c0-2.725-.576-4.746-3.76-4.746-1.53 0-2.556.765-2.975 1.56h-.003V8.85H9.164v10.152h3.055v-5.04c0-1.32.336-2.6 1.972-2.6 1.614 0 1.666 1.51 1.666 2.683v4.957h3.1v-5.585zM23 20.305V2.695A2.698 2.698 0 0020.305 0H2.695A2.698 2.698 0 000 2.695v17.61A2.698 2.698 0 002.695 23h17.61A2.698 2.698 0 0023 20.305zM20.305 1.797a.9.9 0 01.898.898v17.61a.9.9 0 01-.898.898H2.695a.9.9 0 01-.898-.898V2.695a.9.9 0 01.898-.898h17.61z"}})])
          )
        }
      }
    